module.exports = __webpack_public_path__ + "img/22-pool-noodle.b8a8dc0a.jpg";